export default __webpack_public_path__ + "static/media/product_2_friim_2.66d33613.png";